import type { ReactNode } from 'react';
import { createContext, useMemo } from 'react';
import { useProjectContext } from '@gonfalon/app-context/useProjectContext';

export type VegaProject = { projectId: string; projectKey: string };

export const VegaProjectContext = createContext<VegaProject | undefined>(undefined);

export type VegaProjectProviderProps = {
  children: ReactNode;
  projectId?: string;
  projectKey?: string;
};

export function VegaProjectProvider({ children, projectId, projectKey }: VegaProjectProviderProps) {
  const hasExplicitProject = !!(projectId && projectKey);
  const routeContext = useProjectContext({ optional: hasExplicitProject });

  const value = useMemo<VegaProject>(() => {
    if (projectId && projectKey) {
      return { projectId, projectKey };
    }

    if (!routeContext) {
      throw new Error('No project provided');
    }

    return { projectId: routeContext.project._id, projectKey: routeContext.project.key };
  }, [hasExplicitProject, projectId, projectKey, routeContext]);

  return <VegaProjectContext.Provider value={value}>{children}</VegaProjectContext.Provider>;
}
